import React from 'react';

import { useRefreshTokenMutation } from '$/GraphQL/schema/schema';

import { ME } from '$/GraphQL/queries/Users';
import { ADD_ONS, AVAILABLE_ADD_ONS } from '$/GraphQL/queries/Product';
import { GET_SUBSCRIPTION_INFO, GET_MY_ADMIN_TEAM } from '$/GraphQL/queries/Team';
import { GET_SETS_STATUS } from '$/GraphQL/queries/EWebinar';

export const useOnSubscriptionChanged = (): (() => Promise<void>) => {
  const [refreshToken] = useRefreshTokenMutation();
  return React.useCallback(async () => {
    await refreshToken({
      refetchQueries: [
        { query: ME },
        { query: GET_SUBSCRIPTION_INFO },
        { query: GET_MY_ADMIN_TEAM },
        { query: ADD_ONS },
        { query: GET_SETS_STATUS },
        { query: AVAILABLE_ADD_ONS },
      ],
    });
  }, [refreshToken]);
};
